// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"cF","reportCardBox":"cF","report-img-wrap":"cG","reportImgWrap":"cG","report-title":"cH","reportTitle":"cH","report-date":"cI","reportDate":"cI"};